import { render } from "./splitCard.vue?vue&type=template&id=1255cb52&scoped=true"
import script from "./splitCard.vue?vue&type=script&lang=js"
export * from "./splitCard.vue?vue&type=script&lang=js"

import "./splitCard.vue?vue&type=style&index=0&id=1255cb52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1255cb52"]])

export default __exports__